// @ts-strict-ignore
import type {Translatable} from 'common/i18n';

import {SPECIAL_ALL_EVENT_VALUES} from '../constants';
import {getEventDisplayName} from '../display-name-registry';
import {customEventsStore} from '../stores/custom-events';

export function getIconForEvent(eventData) {
  if (
    eventData?.custom ||
    [`$session_start`, `$session_end`, ...SPECIAL_ALL_EVENT_VALUES].includes(eventData?.value || eventData?.name)
  ) {
    return `custom-event-beta`;
  }
  return `event`;
}

export function getEventValueAndLabel({
  name,
  custom,
  id,
}: {
  name?: string | null;
  custom?: boolean;
  id?: number | null;
}) {
  let value: string;
  let label: Translatable;
  if (custom) {
    value = `$custom_event:${id}`;
    label = name || customEventsStore.value[id]?.name;
  } else {
    value = name;
    label = renameEvent(name);
  }
  return {value, label};
}

export function renameEvent(eventName: string) {
  return getEventDisplayName(eventName);
}

export function getEventNameForEntityReferenceBrowse(eventDef) {
  const custom = eventDef.customEventId;
  const eventId = custom ? eventDef.customEventId : eventDef.id;

  const {value} = getEventValueAndLabel({name: eventDef.name, id: eventId, custom});

  return value;
}
